module.exports = __webpack_public_path__ + "img/jardin_de_la_paz.fd735d05.png";